import {
  IGetSettingsResponse,
  IUpdateSettingsDTO,
  IUpdateSettingsResponse,
  SettingsEndpoints,
} from '@/models/settings.model';
import { ApiResponse, httpClient } from '@/utils';

class SettingsAPI {
  static getSettings(): ApiResponse<IGetSettingsResponse> {
    return httpClient.get<IGetSettingsResponse>(SettingsEndpoints.SETTINGS);
  }

  static updateSettings(data: IUpdateSettingsDTO): ApiResponse<IUpdateSettingsResponse> {
    return httpClient.post<IUpdateSettingsResponse>(SettingsEndpoints.SETTINGS, data);
  }
}

export default SettingsAPI;
